import React from 'react';
import { Tab, TabList, makeStyles, shorthands } from '@fluentui/react-components';
import { EngagementTab } from '../hooks/useEngagement';

const useStyles = makeStyles({
	root: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		height: '100%',
		backgroundColor: '#fff',
	},
	tabBar: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		backgroundColor: 'white',
		...shorthands.borderBottom('1px', 'solid', 'rgb(0 0 0 / 10%)'),
		...shorthands.padding('8px', '16px'),
	},
	tab: {
		...shorthands.margin('0', '4px', '0', '0'),
	},
	panel: {
		display: 'flex',
		flex: 1,
		minHeight: 0,
		width: '100%',
		overflowY: 'auto',
	},
});

const TAB_LABELS: Record<EngagementTab, string> = {
	inputs: 'Inputs',
	'ea-chat': 'Chat',
};

interface EngagementLayoutProps {
	selectedTab: EngagementTab;
	visibleTabs: EngagementTab[];
	onTabSelect: (tab: EngagementTab) => void;
	/** Content rendered when the "Inputs" tab is active. */
	inputsContent: React.ReactNode;
	/** Content rendered when the "Chat" tab is active. */
	chatContent: React.ReactNode;
	/** Optional slot rendered to the right of the tab list (e.g. settings icon). */
	headerActions?: React.ReactNode;
}

const EngagementLayout: React.FC<EngagementLayoutProps> = ({
	selectedTab,
	visibleTabs,
	onTabSelect,
	inputsContent,
	chatContent,
	headerActions,
}) => {
	const styles = useStyles();

	return (
		<div className={styles.root}>
			<div className={styles.tabBar}>
				<TabList
					selectedValue={selectedTab}
					onTabSelect={(_event, data) => onTabSelect(data.value as EngagementTab)}
				>
					{visibleTabs.map((tab) => (
						<Tab key={tab} value={tab} className={styles.tab}>
							{TAB_LABELS[tab]}
						</Tab>
					))}
				</TabList>
				{headerActions}
			</div>

			<div className={styles.panel}>
				{selectedTab === 'inputs' && inputsContent}
				{selectedTab === 'ea-chat' && chatContent}
			</div>
		</div>
	);
};

export default EngagementLayout;
